const PageNotFound = () => {
 
  return (
 
     <>Page not found</>

  );
};

export default PageNotFound;